module.exports = __webpack_public_path__ + "static/img/far2_active.ea11bc10.png";